import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PanoramaPhotosphereSelectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"panorama_photosphere_select"}/>
}
